module.exports = __webpack_public_path__ + "static/media/power-plant.e613a99c.svg";